import {
  getPrettyPublisherType,
  TStandardDocumentPublisherType,
} from '../../types/order/documents/shared/interfaces';
import { IUserData } from '../../types/users/IUser';

export const getUserName = (
  users: IUserData[],
  isZillowClosingEnabled: boolean,
  type?: TStandardDocumentPublisherType,
  userId?: string,
): string => {
  const user = users.find((u) => u.id === userId);
  if (userId && user && user.name) {
    return user.name;
  } else {
    return type ? getPrettyPublisherType(type, isZillowClosingEnabled) : '';
  }
};
